import { render, staticRenderFns } from "./Plu.vue?vue&type=template&id=50fef1e8&scoped=true"
import script from "./Plu.vue?vue&type=script&lang=js"
export * from "./Plu.vue?vue&type=script&lang=js"
import style0 from "./Plu.vue?vue&type=style&index=0&id=50fef1e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fef1e8",
  null
  
)

export default component.exports